import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import Lazysizes from 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'es6-promise/auto';
import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.css';

// eslint-disable-next-line import/named
import { createApp } from './main';

const { app, router, store } = createApp();

const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr');

Vue.use(VueAwesomeSwiper);

Vue.use(VueScrollTo, {
  duration: 1000,
  easing: 'ease'
});

Vue.use(VueIziToast);

Lazysizes.cfg.customMedia = {
  '--small': '(max-width: 400px)',
  '--large': '(min-width: 401px)'
};

// Generate CSS files
require('./assets/app.scss');

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__);
}

// wait until router has resolved all async before hooks
// and async components...
router.onReady(() => {
  app.$mount('#app');
});

// Load custom code lazily, so it's non-blocking.
import('./utils/tracking').then((tracking) => tracking.init());
import('./utils/analytics').then((analytics) => analytics.init());

// service worker
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    return false;
  });

  navigator.serviceWorker.register('/service-worker.js');
}



// WEBPACK FOOTER //
// src/entry-client.js